export default __webpack_public_path__ + "static/media/1.3f7d2a67.png";